<div class="intro" [ngClass]="mediaLeft ? 'media-left' : 'media-right'" *ngIf="course$ | async as course">
    <div class="inner-content">
        <h1 *ngIf="courseTitle">
            {{ courseTitle }}
            <span class="last-word">
                {{ lastWord }}
                <span
                    class="label-bestseller"
                    *ngIf="isBestSeller && !isNew && !isWebinar"
                    [innerHTML]="'courses.bestseller' | translate"
                ></span>
                <span
                    class="label-bestseller"
                    [class.new]="isNew && !isBestSeller && !isWebinar"
                    *ngIf="isNew && !isBestSeller"
                    [innerHTML]="'courses.new' | translate"
                ></span>
                <span
                    class="label-bestseller"
                    [class.webinar]="!isNew && !isBestSeller && isWebinar"
                    *ngIf="!isNew && !isBestSeller && isWebinar"
                    [innerHTML]="'courses.webinar' | translate"
                ></span>
                <span
                    class="label-bestseller"
                    *ngIf="isAdditionalKeyword"
                    [innerHTML]="course.keyWords[0]"
                ></span>
            </span>
        </h1>
        <h3 *ngIf="site === 'de_de' && course.training.subTitle">{{course.training.subTitle}}</h3>
        <p *ngIf="showCategories$ | async">
            <strong *ngFor="let division of course.divisions">
                <span>{{ division.name }}</span>
            </strong>
        </p>
        <p>
            <strong *ngIf="course.prices.length > 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                <span [innerHTML]="'courses.price' | translate"></span>
                <br *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value" />
                <span *ngIf="currencyPositionBefore$ | async" class="headline currency-before" [innerHTML]="currency"></span>
                <span *ngIf="course.prices.length === 1 || course.prices.length > 1 && course.prices[1].value === course.prices[0].value"> {{ course.prices[0].value  | currency: '':'':format:languageCode }}</span>
                <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value > 0">{{ course.prices[0].value | currency: '':'':format:languageCode }} - {{ course.prices[1].value | currency: '':'':format:languageCode }}</span>
                <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value === 0">{{ course.prices[1].value | currency: '':'':format:languageCode }}</span>
                <span *ngIf="!(currencyPositionBefore$ | async)" class="headline currency-after" [innerHTML]="currency"></span><span [innerHTML]="'common.perPerson' | translate"></span>
                <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
            </strong>
            <strong class="price" *ngIf="course.price !== undefined && course.prices.length === 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                <span [innerHTML]="'courses.price' | translate"></span>
                <span *ngIf="currencyPositionBefore$ | async" class="headline currency-before" [innerHTML]="currency"></span>
                <span> {{ course.price  | currency: '':'':format:languageCode }}</span>
                <span *ngIf="!(currencyPositionBefore$ | async)" class="headline currency-after" [innerHTML]="currency"></span><span [innerHTML]="'common.perPerson' | translate"></span>
                <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
            </strong>
            <strong class="price" *ngIf="course.metadata && !course.metadata.showPrice">
                <span [innerHTML]="'courses.noPrice' | translate"></span>
            </strong>
        </p>
        <div *ngIf="!isBookedCourse" class="button-wrapper">
            <a *ngIf="showDetailsBtn" da-link [routerLink]="courseDetail" themetype="Secondary" class="button secondary">
                <span [innerHTML]="'buttons.showDetails' | translate"></span>
            </a>

            <a *ngIf="showBookingBtn && course.url" da-link [routerLink]="courseBooking" themetype="Primary" class="button primary">
                <span [innerHTML]="'buttons.bookNow' | translate"></span>
            </a>

            <a
                *ngIf="showBookingBtn && course.isProduct && !course.url"
                da-link
                (click)="addCourseToCart()"
                themetype="Primary"
                class="button primary"
            >
                <span [innerHTML]="'buttons.bookNow' | translate"></span>
            </a>

            <a
                *ngIf="
                    showBookingBtn &&
                    course.metadata &&
                    course.metadata.waitingListEnrolable &&
                    course.events &&
                    !(course.events.length > 0) &&
                    !course.url &&
                    !isOnlineCourse
                "
                da-link
                (click)="addToWishlist()"
                themetype="Secondary"
                class="button secondary"
            >
                <span [innerHTML]="'buttons.prebooking' | translate"></span>
            </a>

            <button
                *ngIf="showDemoBtn && course && course.demo && course.demo.uri !== ''"
                class="button secondary"
                da-button
                themeType="Secondary"
                (click)="openOverlay(course)"
                [innerHTML]="'buttons.viewDemo' | translate"
            ></button>
        </div>
    </div>
    <div class="media" *ngIf="courseImage$ | async as courseImage">
        <figure>
            <da-progressive-image
                [options]="{
                    alt: alt,
                    aspectRatios: [
                        {
                            breakpoint: 360,
                            width: 480,
                            height: 320,
                            akamaiImage: courseImage
                        },
                        {
                            breakpoint: 480,
                            width: 780,
                            height: 520,
                            akamaiImage: courseImage
                        },
                        {
                            breakpoint: 768,
                            width: 480,
                            height: 320,
                            akamaiImage: courseImage
                        },
                        {
                            breakpoint: 960,
                            width: 380,
                            height: 253,
                            akamaiImage: courseImage
                        },
                        {
                            breakpoint: 1120,
                            width: 480,
                            height: 320,
                            akamaiImage: courseImage
                        }
                    ]
                }"
            ></da-progressive-image>
        </figure>
    </div>
</div>
<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="youtubeVideo"></ng-container>
    </div>
</ng-template>
<ng-template #youtubeVideo>
    <iframe id="demo" #iframe></iframe>
</ng-template>
<ng-template #warn>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'addToShopingCart.courseAlreadyInCartTitle' | translate"></h3>
                <p [innerHTML]="'addToShopingCart.courseAlreadyInCartText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<div class="notification" *ngIf="showCartUpdate$ | async as showCartUpdate">
    <div class="modal">
        <div class="location-popup" [ngClass]="showCartUpdate ? 'fade' : ''">
            <div class="title">
                <span class="drg-icon-checkbox_act"></span>
                <span [innerHTML]="'courses.update' | translate"></span>
            </div>
            <div class="inner-wrapper">
                <div class="details">
                    <span>{{ courseTitle }}</span>
                    <span>
                        <span *ngIf="currencyPositionBefore$ | async" class="headline currency-before" [innerHTML]="currency"></span
                        ><span>{{ course.price | currency: '':'':format:languageCode }}</span>
                        <span *ngIf="!(currencyPositionBefore$ | async)" class="headline currency-after" [innerHTML]="currency"></span>
                        <span *ngIf="showVat$ | async" class="vat" [innerHTML]="'common.vatPrice' | translate"></span>
                    </span>
                </div>
                <div class="wrapper" *ngIf="course.url || (course.events && course.events.length === 0)">
                    <div
                        class="wrapper"
                        *ngIf="course.url || (course.events && course.events.length === 0)"
                        [innerHTML]="'courses.online' | translate"
                    ></div>
                </div>

                <div class="wrapper" *ngIf="!course.url && !(course.events && course.events.length === 0)">
                    <div
                        class="wrapper"
                        *ngIf="!course.url && !(course.events && course.events.length === 0)"

                    >
                        <span *ngIf="course.productType === 'SEM' || course.productType === 'WRK'" [innerHTML]="'courses.presence' | translate"></span>
                        <span *ngIf="course.productType === 'WBN'" [innerHTML]="'courses.virtual' | translate"></span>
                    </div>
                </div>
                <a (click)="goToCart()" class="button secondary" [innerHTML]="'courses.showCart' | translate"></a>
            </div>
        </div>
    </div>
</div>
<div class="notification" *ngIf="showCartUpdatePrebooking$ | async as showCartUpdatePrebooking">
    <div class="modal">
        <div class="location-popup" [ngClass]="showCartUpdatePrebooking ? 'fade' : ''">
            <div class="title">
                <span class="checked"></span>
                <span [innerHTML]="'courses.update' | translate"></span>
            </div>
            <div class="inner-wrapper">
                <div class="details">
                    <span>{{ courseTitle }}</span>

                    <div class="price">
                        <span [innerHTML]="'buttons.prebooking' | translate"></span>
                    </div>
                </div>
                <div class="wrapper">
                    <div class="wrapper" [innerHTML]="'courses.prebooking' | translate"></div>
                </div>

                <a (click)="goToCart()" class="button secondary" [innerHTML]="'courses.showCart' | translate"></a>
            </div>
        </div>
    </div>
</div>
<ng-template #warningWishlist>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warnWishlist"></ng-container>
    </div>
</ng-template>
<ng-template #warnWishlist>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'addToShopingCart.courseAlreadyInWishlistTitle' | translate"></h3>
                <p [innerHTML]="'addToShopingCart.courseAlreadyInWishlistText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #notTheSameCurrencyPopup>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="notTheSameCurrencyModal"></ng-container>
    </div>
</ng-template>
<ng-template #notTheSameCurrencyModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'booking.currencyWarningTitle' | translate"></h3>
                <p [innerHTML]="'booking.currencyWarningText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a
                            class="button primary"
                            da-link
                            (click)="goToCart()"
                            [innerHTML]="'courses.showCart' | translate"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
